import StateStorage from './StateStorage';
import {createState, isStateType} from './stateFns';
import {merger} from './mergerFns';

const StateStorageUtil = {
    /**
     * Get storage
     * @returns {array}
     */
    getStorage() {
        return StateStorage.getInstance().getStorage();
    },

    /**
     * Get state by index and ID
     *
     * @param id {string}
     * @param i {number}
     *
     * @returns {Immutable.map}
     */
    getStateByIndex(id, i) {
        const stateStorage = StateStorage.getInstance();
        const currState = stateStorage.getStateByIndex(i || 0);

        return currState.get(id);
    },

    /**
     * Get previous state by ID
     * @param id {string}
     * @returns {Immutable.map}
     */
    getPrevState(id) {
        const stateStorage = StateStorage.getInstance();
        const lastState = stateStorage.getPrevState();

        return lastState.get(id);
    },

    /**
     * Get current state by ID
     * @param id {string}
     * @returns {Immutable.map}
     */
    getState(id) {
        const stateStorage = StateStorage.getInstance();
        const currState = stateStorage.getCurrState();

        return currState.get(id);
    },

    /**
     * Set state by ID
     *
     * @param id {string}
     * @param obj {object|Immutable.map}
     *
     * @returns {boolean}
     */
    setState(id, obj) {
        const stateStorage = StateStorage.getInstance();

        stateStorage.updateStorage(id, isStateType(obj) ? obj : createState(obj));

        return true;
    },

    /**
     * Get value from current state
     * @param id
     * @param key
     * @returns {*}
     */
    getValue(id, key) {
        return StateStorageUtil.getState(id).get(key);
    },

    /**
     * Set value
     *
     * @param id {string}
     * @param key {string}
     * @param value {*}
     *
     * @returns {boolean}
     */
    setValue(id, key, value) {
        const stateStorage = StateStorage.getInstance();
        const currState = stateStorage.getCurrState();

        this.setState(id, currState.get(id).set(key, value));

        return true;
    },

    /**
     * Update state by ID
     *
     * @param id {string}
     * @param obj {object|Immutable.map}
     * @param [overrideMerger] {function} Custom merger
     *
     * @returns {boolean}
     */
    updateState(id, obj, overrideMerger) {
        const stateStorage = StateStorage.getInstance();
        const currState = stateStorage.getCurrState();
        const stateByID = currState.get(id);
        const mergeFn = typeof overrideMerger === 'function' ? overrideMerger : merger;

        this.setState(id, mergeFn(stateByID, obj));

        return true;
    }
};

export default StateStorageUtil;